import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { DecodeVinResponse } from '@app-model/api';
import { CartItem } from '@app-model/cart';
import { UserResponse } from '@app-model/login';
import * as fromRoot from '@app-store/reducers';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe],
  styleUrls: ['./quote-print-template.component.scss'],
  templateUrl: './quote-print-template.component.html',
})
export class QuotePrintTemplateComponent {
  private store$ = inject<Store<fromRoot.State>>(Store);

  @Input({ required: true }) navbarLogo: string | ArrayBuffer = '';

  user: Signal<UserResponse> = toSignal(this.store$.select((state) => state.userState.user));
  cart: Signal<CartItem[]> = toSignal(this.store$.select((state) => state.cartState.validatedCart));
  vehicle: Signal<DecodeVinResponse> = toSignal(this.store$.select((state) => state.vehicleState.vin));
  date: Date = new Date();
  readonly amountOfContractOnFirstPage: number = 5;
  readonly amountOfContractOnRestPages: number = 12;
}
